<div class="container" >
    <tick-box2 ></tick-box2>
</div>
  